import styled from '@emotion/styled';
import { SingleSelect } from 'src/web/components/Input/DropdownsOld/SingleSelect';
import {
  OL_COLOUR_BLACK_10,
  OL_COLOUR_BLACK_4,
  OL_COLOUR_BLACK_90_HEX,
} from 'src/web/components/Style/colours';

export const CourseItemTr = styled('tr')({
  '&:not(:last-child)': {
    borderBottom: `1px solid ${OL_COLOUR_BLACK_10}`,
  },
});

export const CourseItemTh = styled('th')({
  padding: '20px 0',
  color: OL_COLOUR_BLACK_90_HEX,
  background: OL_COLOUR_BLACK_4,
  fontWeight: 600,
  textAlign: 'left',
  '&:first-child': {
    paddingLeft: 20,
  },
  '&:last-child': {
    paddingRight: 20,
  },
});

export const CourseItemTd = styled('td')({
  padding: '20px 0',
  verticalAlign: 'baseline',
  '&:first-child': {
    paddingLeft: 20,
  },
  '&:last-child': {
    paddingRight: 20,
  },
});

export const CoursesListTable = styled('table')({
  marginTop: 20,
  border: `1px solid ${OL_COLOUR_BLACK_10}`,
  width: '100%',
  fontSize: 14,
});

export const StyledSingleSelect = styled(SingleSelect)({
  '.react-selectize.root-node': {
    width: 200,
  },
});

export const ClassesInRoleCell = styled('div')({
  width: 355,
});

export const StaffRoleOptionsTable = styled('table')({
  marginTop: 20,
  th: {
    fontWeight: 600,
  },
  'td, th': {
    textAlign: 'start',
    paddingBottom: 8,
    paddingRight: 12,
  },
});
